<template lang="pug" src="./login.pug"></template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import idioma from '../../../../build/language/index.js'
import { trackAnalyticsEvent } from '../../../utils/analytics.js'
import PATHS from '../../../router/routesMap.js'

export default {
  name: 'Login',

  components: { VueRecaptcha },

  data () {
    return {
      PUBLIC_KEY: '6Lcr0awUAAAAAFQhGvyrtVnXKHS4c2d2r_qnBzaK',
      isProbableABot: false,
      isLogin: true,
      username: '',
      pass: '',
      responsePasswordRecoveryCaptcha: null,
      responseLoginCaptcha: null,
      abrirIdiomas: false,
      captchaOK: false,
      msgErroCriacaoCaptcha: false,
      msgCaptchaErro: false,
      logadoSuccess: false,
      logadoError: false,
      campoUsernameVazio: false,
      campoPassVazio: false,
      campoUsernameInvalido: false,
      destFileCaptcha: '',
      numeroCaptcha: '',
      disableLoginButton: false,
      disableRecoveryButton: false,
      idiomaPng: require('../../../assets/login/img/idioma.png'),
      idiomaAtivoPng: require('../../../assets/login/img/idioma-ativo.png'),
      logoEqualsLoginPng: require('../../../assets/logos_equals/logo_banking.png'),
      userPng: require('../../../assets/login/img/user.png'),
      passwordPng: require('../../../assets/login/img/password.png'),
      fecharPng: require('../../../assets/login/img/fechar.png'),
      logadoOkPng: require('../../../assets/login/img/logado-ok.png'),
      voltarPng: require('../../../assets/login/img/voltar.png')
    }
  },

  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },

    messageErrorLogin () {
      return this.$store.getters.messageErrorLogin
    }
  },

  watch: {
    messageErrorLogin () {
      if (this.messageErrorLogin) {
        this.$root.$refs.notification.warning('erro')
        this.$store.dispatch('cleanMessageErrorSession')
      }
    },

    username () {
      if (this.username && this.username.length > 0) {
        this.campoUsernameVazio = false
        this.campoUsernameInvalido = false
        let inputId = this.isLogin ? 'loginInputLog' : 'loginInputRec'
        document.getElementById(inputId).style.borderBottom = '2px solid #ffffff'
      }
    },

    pass () {
      if (this.pass && this.pass.length > 0) {
        this.campoPassVazio = false
        document.querySelector('#loginSenha').style.borderBottom = '2px solid #ffffff'
      }
    }
  },

  methods: {
    escolherIdioma () {
      this.abrirIdiomas = true
    },

    fecharEscolherIdioma () {
      this.abrirIdiomas = false
    },

    trocarIdioma (language) {
      idioma.changeLanguage(language)

      $('div.btn-group').find('.btn-ativo').removeClass('btn-ativo')

      switch (language) {
        case 'pt':
          $('.btn-pt').addClass('btn-ativo')
          break
        case 'in':
          $('.btn-in').addClass('btn-ativo')
          break
        case 'es':
          $('.btn-es').addClass('btn-ativo')
          break
        default:
          break
      }
    },

    login (event) {
      localStorage.removeItem('token')
      event.preventDefault()
      if (this.responseLoginCaptcha === null && this.isProbableABot) {
        this.$root.$refs.notification.error('login.validacao.recaptcha')
        return
      }
      if (this.validateForm()) {
        this.disableLoginButton = true
        this.$store.dispatch('login', {
          username: this.username,
          password: this.pass,
          recaptcha: this.responseLoginCaptcha
        }).then((response) => {
          this.$store.dispatch('setClient', {client: null, clientName: null, singleClient: null})
            .then(async () => {
              await trackAnalyticsEvent(this, 'tentativa-de-login', 'login-click', idioma.getCookieByName('language'))
              this.$store.dispatch('getClients')
                .then((clients) => {
                  this.$root.$refs.notification.success('login.sucesso.login')
                  location.href = PATHS.HOME
                  this.disableLoginButton = false
                })
                .catch((error) => {
                  this.$store.dispatch('logout')
                    .then(() => {
                      this.$store.dispatch('cleanVuexModules').then(() => {
                        this.$root.$refs.notification.error(error.message)
                        this.disableLoginButton = false
                      })
                    })
                })
                .finally(() => {
                  localStorage.setItem('event-login-done', Math.random())
                })
            })
        }).catch((error) => {
          this.isProbableABot = error.triesAmount >= 5
          let errorMessageSplitted = error.message.split('  ')
          if (errorMessageSplitted[0] === 'login.erro.usuario.senhaBloqueada') {
            trackAnalyticsEvent(this, 'tentativa-de-login', 'login-click', 'senha-bloqueada')
          }
          this.disableLoginButton = false
          if (errorMessageSplitted[0] === 'No message available') {
            this.$root.$refs.notification.error('GENERAL', 'login.erro.verificarEmailSenha')
          // acontece quando nao recebe resposta do node
          } else if (errorMessageSplitted[0] === "Cannot read property 'status' of undefined") {
            this.$root.$refs.notification.error('GENERAL', 'login.erro.loginTitle')
          } else {
            this.$root.$refs.notification.error(errorMessageSplitted[0], 'login.erro.loginTitle')
          }
        })
      }
    },

    logout () {
      this.$store.dispatch('logout').then(() => {
        localStorage.removeItem('token')
        this.$router.push('/')
      })
    },

    validateEmail (email) {
      return (/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/).test(this.username)
    },

    validateForm () {
      // Não pode fazer o retorno direto das funções de validação para
      // garantir que ambos o campos do form sejam validados na ação.
      let isValidUsername = this.verifyUsernameEmpty()
      let isValidPass = this.verifyPasswordEmpty()
      return isValidUsername && isValidPass
    },

    verifyUsernameEmpty () {
      let inputId = this.isLogin ? 'loginInputLog' : 'loginInputRec'
      let isValid = true
      this.campoUsernameVazio = false
      this.campoUsernameInvalido = false
      if (this.username == null || this.username === undefined || this.username === '') {
        this.campoUsernameVazio = true
        document.getElementById(inputId).style.borderBottom = '2px solid #c65b55'
        isValid = false
      } else if (!this.validateEmail()) {
        this.campoUsernameInvalido = true
        document.getElementById(inputId).style.borderBottom = '2px solid #c65b55'
        isValid = false
      }
      return isValid
    },

    verifyPasswordEmpty () {
      let isValid = true
      this.campoPassVazio = false
      if (this.pass == null || this.pass === undefined || this.pass === '') {
        this.campoPassVazio = true
        document.querySelector('#loginSenha').style.borderBottom = '2px solid #c65b55'
        isValid = false
      }

      return isValid
    },

    limparErro () {
      this.logadoError = false
      $('.form-control').css('border-bottom', '2px solid rgba(255, 255, 255, 1)')
    },

    animacaoTela: function (step) {
      step.addClass('animate-out')

      setTimeout(function () {
        step.removeClass('animate-out is-showing').next().addClass('animate-in')
      }, 400)

      setTimeout(function () {
        step.next().removeClass('animate-in').addClass('is-showing')
      }, 1200)
    },

    // Troca de tela da tela de login para tela de recuperar senha
    trocaTelaRecuperarSenha: function () {
      var self = this
      self.isLogin = false
      var step = $('.inicial-body2')
      if (this.campoUsernameVazio || this.campoUsernameInvalido) {
        document.getElementById('loginInputRec').style.borderBottom = '2px solid #c65b55'
      }
      self.animacaoTela(step)
    },

    // Troca de tela da tela de recuperação de senha para tela de login
    trocaTelaVoltar: function () {
      this.isLogin = true
      this.campoPassVazio = false
      this.campoUsernameVazio = false
      this.campoUsernameInvalido = false
      this.username = ''
      this.pass = ''
      document.querySelector('#loginSenha').style.borderBottom = '2px solid white'
      document.querySelector('#loginInputLog').style.borderBottom = '2px solid white'
      document.querySelector('#loginInputRec').style.borderBottom = '2px solid white'
      var step = $('.inicial-body3')

      step.addClass('animate-out')

      setTimeout(function () {
        step.removeClass('animate-out is-showing').prev().addClass('animate-in')
      }, 400)

      setTimeout(function () {
        step.prev().removeClass('animate-in').addClass('is-showing')
      }, 1200)
    },

    removeSpaces: function (string) {
      return string.split(' ').join('')
    },

    onVerify (response) {
      this.responsePasswordRecoveryCaptcha = response
    },

    onVerifyLogin (response) {
      this.responseLoginCaptcha = response
    },

    recoverPassword (event) {
      event.preventDefault()
      if (!this.responsePasswordRecoveryCaptcha) {
        this.$root.$refs.notification.error('login.validacao.recaptcha')
        return
      }

      if (this.verifyUsernameEmpty()) {
        this.disableRecoveryButton = true
        let recoverPasswordData = {
          username: this.username,
          url: 'http://' + window.location.host + '/banking/',
          recaptcha: this.responsePasswordRecoveryCaptcha
        }
        this.$store.dispatch('recoverPassword', recoverPasswordData).then((response) => {
          this.$root.$refs.notification.success('login.sucesso.recuperarSenha')
          trackAnalyticsEvent(this, 'tentativa-de-recuperar-senha', 'recuperar-senha', 'sucesso')
          this.disableRecoveryButton = false
          this.trocaTelaVoltar()
        }).catch((error) => {
          trackAnalyticsEvent(this, 'tentativa-de-recuperar-senha', 'recuperar-senha', 'erro')
          this.disableRecoveryButton = false
          this.$root.$refs.notification.error(error.message)
        })
      }
    },

    carregarImagem (nomeImagem) {
      var idiomaImagem = idioma.getCookieByName('language')
      return require('../../../assets/login/img/' + nomeImagem + idiomaImagem + '.png')
    }
  },

  mounted () {
    this.$store.dispatch('tentativas').then(response => {
      this.isProbableABot = response.triesAmount >= 5
    })
    if (localStorage.getItem('SESSION_ERR')) {
      this.$root.$refs.notification.warning(localStorage.getItem('SESSION_ERR'))
      localStorage.removeItem('SESSION_ERR')
    }

    if (localStorage.getItem('UNAUTHORIZED') === 'UNAUTHORIZED') {
      this.$root.$refs.notification.warning('naoAutorizado.labels.mensagem401')
    } else if (localStorage.getItem('SESSION_ERR')) {
      this.$root.$refs.notification.warning(localStorage.getItem('SESSION_ERR'))
      localStorage.removeItem('SESSION_ERR')
    }

    localStorage.setItem('UNAUTHORIZED', null)

    idioma.changeLanguage(idioma.getCookieByName('language'))

    // Deixa ativo o botão do idioma selecionado.
    switch (idioma.getCookieByName('language')) {
      case 'pt':
        $('.btn-pt').addClass('btn-ativo')
        break
      case 'in':
        $('.btn-in').addClass('btn-ativo')
        break
      case 'es':
        $('.btn-es').addClass('btn-ativo')
        break
      default:
        break
    }
  }
}
</script>

<style scoped>
/*Tela de login*/

.recaptcha-form {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

.bg-tela-login:after {
  content: "";
  position: fixed;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  left: 0;
  right: 0;
  height: 8px;
}

.bg-tela-login:after {
  bottom: 0;
}

.bg-tela-login {
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-color: #223768;
  background: #223768;
  background: -webkit-linear-gradient(left, #1C3B65, #40B9BB);
  background: -o-linear-gradient(right, #223768, #00C3BE);
  background: -moz-linear-gradient(right, #223768, #00C3BE);
  background: linear-gradient(to right, #223768, #00C3BE);
  height: auto !important;
  min-height: 100vh;
}

.inicial-wrap {
  font-family: 'Inter', sans-serif;
  max-width: 650px;
  margin: 20px auto;
  -webkit-transition: -webkit-transform 300ms ease-in-out;
  transition: -webkit-transform 300ms ease-in-out;
  transition: transform 300ms ease-in-out;
  transition: transform 300ms ease-in-out, -webkit-transform 300ms ease-in-out;
}

.inicial-bodies {
  font-family: 'Inter', sans-serif;
  text-align: center;
  position: relative;
  -webkit-perspective: 1000px;
  perspective: 1000px;
}

button.button {
  font-family: 'Inter', sans-serif;
  background-color: rgba(174, 223, 120, 1);
  font-size: 20px;
  cursor: pointer;
  margin-top: 60px !important;
  color: rgba(28, 59, 101, 1);
  text-transform: uppercase;
  width: 100%;
  height: 60px;
  border: none;
}

button.button:hover {
  background-color: rgba(174, 223, 120, 1);
  color: rgba(28, 59, 101, 1);
  border: none;
}

.button i {
  font-weight: normal;
  font-size: 24px;
  margin-right: 5px;
}

/*Tela de boas vindas*/

.boas-vindas-tit {
  text-align: center;
  font-size: 50px;
  color: rgba(122, 203, 231, 1);
}

.boas-vindas-txt {
  text-align: center;
  padding: 50px 145px 50px 145px;
  font-size: 25px;
  color: rgba(255, 255, 255, 1);
}

.boas-vindas-txt-bottom {
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
  color: rgba(122, 203, 231, 1);
}

@media screen and (min-width: 992px) {

  .inicial-body {
    background: #005E78;
    padding: 40px 0px 0px 0px;
    margin-bottom: 20px;
    display: none;
    box-sizing: border-box;
    width: 100%;
  }

  .inicial-body2 {
    border: 2px solid rgba(255, 255, 255, 1);
    margin-bottom: 76px;
    display: none;
    width: 100%;
  }

  .inicial-body3 {
    border: 2px solid rgba(255, 255, 255, 1);
    margin-bottom: 20px;
    display: none;
    width: 100%;
  }

  .formulario-login {
    padding: 80px 125px 50px 125px;
    box-sizing: border-box;
    width: 100%;
  }

}

@media screen and (max-width: 991px) {

  .inicial-body {
    background: #005E78;
    padding: 40px 0px 0px 0px;
    margin-bottom: 20px;
    display: none;
    box-sizing: border-box;
    width: 100%;
  }

  .inicial-body2 {
    border: 2px solid rgba(255, 255, 255, 1);
    margin-bottom: 74px;
    display: none;
    width: 100%;
  }

  .inicial-body3 {
    border: 2px solid rgba(255, 255, 255, 1);
    margin-bottom: 20px;
    display: none;
    width: 100%;
  }

  .formulario-login {
    padding: 80px 50px 50px 50px;
    box-sizing: border-box;
    width: 100%;
  }

}

.formulario-login-topo {
  height: 115px;
  background-color: #FFF;
}

.formulario-login-topo-logo {
  z-index:1;
  position: absolute;
  width:100%;
  max-width: 100%;
  text-align: left;
  padding: 22px 0px;
}

img.logo-img {
  max-height:60px;
  margin-top:8px;
  padding-left:20px;
}

p.logo-txt {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  color: #1c3b65;
  font-size: 30px;
  text-transform: capitalize;
}

button.btn-idioma {
  background: #fff;
  float: right;
  height: 100%;
  padding: 2%;
  border: none;
}

button.btn-idioma:hover {
  background: transparent;
  border: none;
}

button.btn-idioma:active {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.escolhaIdiomas {
  background: rgba(133, 186, 202, 1);
  /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(left, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));
  /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(right, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));
  /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(right, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));
  /* For Firefox 3.6 to 15 */
  background: linear-gradient(to right, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));
  /* Standard syntax */
  height: 50px;
  z-index: 2;
}

.escolhaIdiomas p {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  color: rgba(28, 59, 101, 1);
  padding: 15px;
  font-weight: bold;
  vertical-align: middle;
}

button.btn-escolher-idioma {
  font-family: 'Inter', sans-serif;
  border: none;
  font-size: 15px;
  background-color: transparent;
  padding: 14px 10px 15px 10px;
  color: rgba(255, 255, 255, 1);
}

button.btn-escolher-idioma.btn-ativo {
  border: none;
  background-color: rgba(224, 239, 244, 1);
  padding: 14px 10px 10px 10px;
  border-bottom: 5px solid rgba(28, 59, 101, 1);
  color: rgba(28, 59, 101, 1);
}

button.btn-escolher-idioma:hover {
  border: none;
  background-color: rgba(224, 239, 244, 1);
  padding: 14px 10px 10px 10px;
  border-bottom: 5px solid rgba(28, 59, 101, 1);
  color: rgba(28, 59, 101, 1);
}

button.btn-fechar-escolher-idioma {
  background-color: transparent;
  padding: 0px;
  margin: 0px 6px 0px 25px!important;
  border: none;
}

button.btn-fechar-escolher-idioma:hover {
  background-color: transparent;
  border: none;
}

button.btn-fechar-escolher-idioma:active {
  background-color: transparent;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

button.btn-esqueceu-senha {
  background-color: transparent;
  border: none;
  z-index: 2;
  position: absolute;
  height: 60px;
  width: 60px;
  right: 0;
  text-align: center;
  padding: 0px;
}

button.btn-esqueceu-senha:hover {
  background-color: transparent;
  border: none;
}

button.btn-esqueceu-senha:active {
  background-color: transparent;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.logo-equals {
  height: 100%;
  padding: 2%;
}

.text-white {
  color: #fff;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-animation: autofill 0s forwards;
  animation: autofill 0s forwards;
  -webkit-text-fill-color: #fff !important;
}

@keyframes autofill {
  100% {
    background: rgba(255, 255, 255, 0.15);
    color: inherit;
  }
}

@-webkit-keyframes autofill {
  100% {
    background: rgba(255, 255, 255, 0.15);
    color: inherit;
  }
}

.formulario-login input {
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 0px!important;
  border: none;
  border-bottom: 2px solid rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  height: 60px;
}

.formulario-login input:focus {
  -webkit-box-shadow: 0 0 0px 1000px rgba(255, 255, 255, 0.15) inset !important;
  box-shadow: 0 0 0px 1000px rgba(255, 255, 255, 0.15) inset !important;
}

.formulario-login input::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 1)!important;
}

.formulario-login input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgba(255, 255, 255, 1)!important;
}

.formulario-login input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgba(255, 255, 255, 1)!important;
  opacity: 0.4;
}

.formulario-login input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: rgba(255, 255, 255, 1)!important;
}

button.button-login {
  font-family: 'Inter', sans-serif;
  background-color: rgba(28, 59, 101, 1);
  bottom: 0;
  font-size: 20px;
  cursor: pointer;
  color: rgba(255, 255, 255, 1);
  text-transform: uppercase;
  width: 100%;
  height: 60px;
  border: none;
}

button.button-login:hover {
  background-color: rgba(64, 185, 187, 1);
  color: rgba(255, 255, 255, 1);
  border: none;
}

button.button-login:active {
  background-color: rgba(28, 59, 101, 1);
  color: rgba(255, 255, 255, 1);
  border: none;
}

button.button-login:disabled {
  background-color: rgba(28, 59, 101, 1);
  cursor: progress;
  color: #FFF;
  border: none;
}

/*Captcha*/

.captcha {
  font-family: 'Inter', sans-serif;
  background-color: #FFF;
  padding: 20px 10px;
}

.captcha p {
  width: 100%;
  font-size: 15px;
  margin-top: 10px;
}

#mainCaptcha {
  width: 90%;
  background-color: transparent;
  color: black;
  text-align: center;
  padding: 0px;
}

.text-center {
  text-align: center;
}

button.btn-refresh-catpcha {
  width: 10%;
  background-color: transparent;
  padding: 0px;
  border: none;
}

button.btn-refresh-catpcha:hover {
  background-color: transparent;
  border: none;
}

button.btn-refresh-catpcha:active {
  background-color: transparent;
  border: none;
}

input.captcha-recuperar-senha {
  padding: 8px;
  width: 100%;
  /* background-color: rgba(95, 169, 192, 1); */
  border-radius: 0px!important;
  border: none;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
}

.g-recaptcha {
  display: inline-block;
}

input.captcha-recuperar-senha::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 1)!important;
}

input.captcha-recuperar-senha:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgba(255, 255, 255, 1)!important;
}

input.captcha-recuperar-senha::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgba(255, 255, 255, 1)!important;
}

input.captcha-recuperar-senha:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: rgba(255, 255, 255, 1)!important;
}

button.button2 {
  margin-top: 20px!important;
  background-color: transparent;
  border: none;
  color: rgba(28, 59, 101, 1);
  padding: 0px;
}

button.button2:hover {
  background-color: transparent;
  border: none;
  color: rgba(28, 59, 101, 1);
}

button.button2:active {
  background-color: transparent;
  border: none;
  color: rgba(28, 59, 101, 1);
  background-color: transparent;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

button.button2 span {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  margin-left: 8px;
  font-weight: bold;
}

/*Tela logado*/

.logado {
  font-family: 'Inter', sans-serif;
  background-color: rgba(147, 191, 98, 1);
  color: rgba(255, 255, 255, 1);
}

.logado-ok {
  font-size: 50px;
  margin: 30px 0px 10px 0px;
}

.bem-vindo {
  font-size: 20px;
  text-transform: uppercase;
}

.img-bottom {

  height: 90px;
  /*max-width: 650px;*/
  vertical-align: middle;
  margin-bottom: 30px;
  /*position: absolute;*/
}

/*Login com erro*/

.erro-login {
  color: rgba(106, 34, 35, 1);
  margin-top: 5px;
  font-size: 14px;
  font-style: italic;
}

.inicial-body.is-showing {
  display: block;
}

.inicial-body2.is-showing {
  display: block;
}

.inicial-body3.is-showing {
  display: block;
}

.animate-out {
  -webkit-animation: out 600ms ease-in-out;
  animation: out 600ms ease-in-out;
}

.animate-in {
  -webkit-animation: in 400ms ease-in-out;
  animation: in 400ms ease-in-out;
  display: block;
}

.animate-up {
  -webkit-transform: rotateY(0deg);
  transform: rotateY(0deg);
}

.form-control {
  font-family: 'Inter', sans-serif;
}

html,
body {
  height: 100%;
}

body {
  overflow: auto;
}

.vertical-center {

  /* Make it a flex container */
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  /* Align the bootstrap's container vertically */
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  width: 100%;

  -webkit-box-pack: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}

.jumbotron.vertical-center {
  margin-bottom: 0;
}

#loginInputLog, #loginInputRec {
  padding-left: 50px;
}

#loginSenha {
  padding-left: 50px;
}

.inicial-wrap.px-0.img-bottom div {
  padding-bottom: 15px;
}

.formulario-login .form-group>img {
  background-color: transparent;
  border: none;
  position: absolute;
  left: 0;
  text-align: center;
  padding: 15px;
}

.recuperarSenha {
  padding: 10px 0px;
  color: #FFF;
}

.recuperarSenha a {
  color: #FFF;
}

.recuperarSenha a:hover {
  text-decoration: underline;
}

@-webkit-keyframes out {
  0% {
    opacity: 1;
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
  }
  100% {
    opacity: 0;
    -webkit-transform: rotateY(-90deg);
    transform: rotateY(-90deg);
  }
}

@keyframes out {
  0% {
    opacity: 1;
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
  }
  100% {
    opacity: 0;
    -webkit-transform: rotateY(-90deg);
    transform: rotateY(-90deg);
  }
}

@-webkit-keyframes in {
  0% {
    opacity: 0;
    -webkit-transform: rotateY(90deg);
    transform: rotateY(90deg);
  }
  100% {
    opacity: 1;
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
  }
}

@keyframes in {
  0% {
    opacity: 0;
    -webkit-transform: rotateY(90deg);
    transform: rotateY(90deg);
  }
  100% {
    opacity: 1;
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
  }
}
</style>



// WEBPACK FOOTER //
// Login.vue?6f85a392